import { useMutation } from 'react-query';
import { httpService } from '../../../../../services/http.service';
import { BASE_URL } from '../../../../../constants/endpoints';
import { useStore } from '../../../../../store';
import { IServerErrorResponse } from '../../../../../types';

interface IProps {
    billId: string,
    vendorEmail: string
}

export const useNotifyVendor = (onSuccess: () => void, onError: (data: IServerErrorResponse) => void) => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useMutation(
    async (props : IProps) => {
      const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${props.billId}/notifyVendorUponPayment`, {
        email: props.vendorEmail,
      });
      return data;
    },
    {
      onSuccess,
      onError,
    },
  );
};
